import React, { useEffect, useMemo, useState } from 'react';
import { ChevronRightIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import axiosInstance from '../../../axiosConfig';

type Meldung = { id: number; label: string };

const DtausEinzugPage: React.FC = () => {
  const [meldungen, setMeldungen] = useState<Meldung[]>([]);
  const [query, setQuery] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await axiosInstance.get<Meldung[]>('/sepa-dateien/list');
        setMeldungen(res.data);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Fehler beim Abruf von SEPA-Dateien Liste:', err);
      }
    })();
  }, []);

  const buildDetailLink = (item: Meldung) => ({
    pathname: `/dtaus-direct-debit/${item.id}`,
    search: `?title=${encodeURIComponent(item.label)}`,
  });

  const filteredMeldungen = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return meldungen;
    return meldungen.filter((m) => {
      const label = (m.label || '').toLowerCase();
      const id = String(m.id).toLowerCase();
      return label.includes(q) || id.includes(q);
    });
  }, [meldungen, query]);

  return (
    <div className="px-6">
      <div className="bg-white border rounded-md p-4">
        <h1 className="text-xl font-semibold mb-2">SEPA Dateien</h1>
        <p className="text-gray-600 mb-4">Bitte wählen Sie die Meldung:</p>
        <div className="mb-3">
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Nach Meldung suchen..."
            aria-label="Meldungen suchen"
            autoComplete="off"
            className="w-full focus:outline-none active:outline-none focus:ring-0 focus:border-gray-400 border rounded-md px-3 py-1.5"
          />
        </div>
        {filteredMeldungen.length === 0 ? (
          <div className="text-center py-10 text-gray-500">
            <ExclamationTriangleIcon className="w-10 h-10 mx-auto mb-4" />
            <b>Keine Meldungen gefunden.</b>
            {query && (
              <div className="text-xs text-gray-500 mt-2">
                Für "<span className="font-semibold text-gray-700">{query}</span>" wurden keine Ergebnisse gefunden. <br /> Bitte versuchen Sie es mit einem anderen Suchbegriff.
              </div>
            )}
          </div>
        ) : (
          <ul className="pl-1 space-y-1" aria-label="Meldungen">
            {filteredMeldungen.map((m) => (
              <li
                key={m.id}
                className="group text-sm border-b flex items-center gap-2 rounded-md px-2 transition-colors hover:bg-gray-50 hover:border-gray-300 cursor-pointer"
              >
                <ChevronRightIcon className="w-3 h-3 text-gray-400 transition-colors group-hover:text-[#52A445]" />
                <Link
                  to={buildDetailLink(m)}
                  aria-label={`Meldung auswählen: ${m.label}`}
                  className="flex items-center gap-2 w-full py-1.5"
                >
                  <span className="flex-1 transition-colors font-medium group-hover:underline group-hover:text-[#52A445]">
                    {m.label}
                  </span>
                  <span className="ml-auto text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity group-hover:text-[#52A445]">
                    Auswählen
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default DtausEinzugPage;


